import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useGetRates, useGetServices, useGetSpaceCategories } from '../../../queries';

interface UseRequiredFieldsDataProps {
    promotedServiceId: string;
    enterpriseId: string;
    serviceId: string;
}

export const useRequiredFieldsData = ({ enterpriseId, promotedServiceId, serviceId }: UseRequiredFieldsDataProps) => {
    const { data: serviceData, isFetching: isServiceDataLoading } = useGetServices(enterpriseId, serviceId);
    const { data: rateData, isFetching: isRateDataLoading } = useGetRates({
        serviceId: promotedServiceId,
        enterpriseId,
    });
    const { data: spaceCategoryData, isFetching: isSpaceCategoryDataLoading } = useGetSpaceCategories({
        serviceId: promotedServiceId,
        enterpriseId,
    });

    const isLoading = isRateDataLoading || isSpaceCategoryDataLoading || isServiceDataLoading;
    const selectedService = serviceData
        ? pipe(
              serviceData,
              array.findFirst((service) => service.id === promotedServiceId),
              option.getOrElseW(() => undefined)
          )
        : undefined;

    return { spaceCategoryData, rateData, selectedService, isLoading };
};
